export const geoApioptions = {
	method: 'GET',
	headers: {
		'X-RapidAPI-Key': '6f1e947422msh0bad9d843c38a0bp1d7d87jsn3e62259e0172',
		'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
	}
};

export const GEO_API_URL = 'https://wft-geo-db.p.rapidapi.com/v1/geo';
export const WEATHER_API_URL = 'https://api.openweathermap.org/data/2.5';
export const WEATHER_API_KEY = 'dc969b2ba494ec4599bc95982a6c03eb';

